import { useEffect as c } from "react";
const d = (...n) => {
  const [r, ...o] = n.reverse(), e = (s) => {
    o.every((t) => t.current && !t.current.contains(s.target)) && r();
  };
  c(() => (document.addEventListener("mousedown", e), () => {
    document.removeEventListener("mousedown", e);
  }), []);
};
export {
  d as default
};
